import {useABTest} from "@pg-mono/ab-testing";

import {abTestingInstance} from "../../ab_testing/ab_testing_instance";
import {LeadFormVariant, OngoingABTests} from "../../ab_testing/ongoing_ab_tests";

const leadFormSimplifiedAbTestInstance = abTestingInstance.getABTestContainerProps(OngoingABTests.LEAD_FORM_SIMPLIFIED);

export const useLeadFormSimplifiedAbTest = () => {
    const {abTestVariant} = useABTest(leadFormSimplifiedAbTestInstance);

    const isStandardFormVariant = abTestVariant === LeadFormVariant.STANDARD;
    const isFullOfferFormVariant = abTestVariant === LeadFormVariant.FULL_OFFER;

    return {
        abTestVariant,
        isStandardFormVariant,
        isFullOfferFormVariant
    };
};
import {useABTest} from "@pg-mono/ab-testing";

import {abTestingInstance} from "../../ab_testing/ab_testing_instance";
import {LeadFormVariant, OngoingABTests} from "../../ab_testing/ongoing_ab_tests";

const leadFormSimplifiedAbTestInstance = abTestingInstance.getABTestContainerProps(OngoingABTests.LEAD_FORM_SIMPLIFIED);

export const useLeadFormSimplifiedAbTest = () => {
    const {abTestVariant} = useABTest(leadFormSimplifiedAbTestInstance);

    const isStandardFormVariant = abTestVariant === LeadFormVariant.STANDARD;
    const isFullOfferFormVariant = abTestVariant === LeadFormVariant.FULL_OFFER;

    return {
        abTestVariant,
        isStandardFormVariant,
        isFullOfferFormVariant
    };
};
